import { OrganizationNode } from "../../../services/organizations";
import { useOrganizationsScreenContext } from "../../../context/organizations/OrganizationsScreenContextProvider";
import ActivityLogMain from "./ActivityLog/ActivityLogMain";
import MessagesLogMain from "./MessagesLog/MessagesLogMain";
import OrganizationProfileMain from "./OrganizationProfile/OrganizationProfileMain";
import OrganizationsHeader from "./OrganizationsHeader";
import OrganizationsListMain from "./OrganizationsList/OrganizationsListMain";
import OrganizationsSideFilter from "./OrganizationsSideFilter";

function MainPage() {
  const {
    selectedTab,
    setSelectedTab,
    isAllOrganizationsSelected,
    setIsAllOrganizationsSelected,
  } = useOrganizationsScreenContext();

  const handleDefaultParentSelect = () => {
    setIsAllOrganizationsSelected(true);
    setSelectedTab("organizationsList");
  };

  const handleLocationSelect = (node: OrganizationNode) => {
    const children = node.isClient
      ? node.branches
      : node.isBranch
        ? node.subBranches
        : [];

    setIsAllOrganizationsSelected(false);
    setSelectedTab(
      children.length ? "organizationsList" : "organizationProfile",
    );
  };

  return (
    <div className="w-full h-full min-h-0 overflow-hidden">
      <div className="w-full h-full bg-grayLightBg flex gap-1">
        <OrganizationsSideFilter
          isDefaultParentSelected={isAllOrganizationsSelected}
          onDefaultParentSelect={handleDefaultParentSelect}
          onLocationSelect={handleLocationSelect}
        />

        <div className="flex-1 flex flex-col gap-1 min-h-0 overflow-y-auto">
          {/* Header */}
          <OrganizationsHeader />

          {selectedTab === "organizationsList" && <OrganizationsListMain />}

          {selectedTab === "organizationProfile" && <OrganizationProfileMain />}

          {selectedTab === "activityLog" && <ActivityLogMain />}

          {selectedTab === "messagesLog" && <MessagesLogMain />}
        </div>
      </div>
    </div>
  );
}

export default MainPage;
